import React, { useEffect } from 'react';
import ReactSlickHero from '../components/ReactSlickHero';
import Services from '../components/Services';
import Countries from '../components/Countries';
import '../styles/HomePage.css';

const HomePage = () => {
  // Component mount olduğunda sayfayı en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home-page">
      <ReactSlickHero />
      <Services />
      <Countries isHomePage={true} />
      <section className="cta-section">
        <div className="container">
          <h2>Hayalinizdeki Kariyere Bir Adım Daha Yaklaşın</h2>
          <p>Uzman ekibimiz, Avrupa'daki yeni hayatınıza adım atmanız için yanınızda.</p>
          <a href="/iletisim" className="btn btn-primary">Hemen İletişime Geçin</a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;